import { FONTS } from '../../../../constants/fonts';
import {
    ptFactor,
    SIZE_OPTIONS, sizeScale, textWidthDp, textWidthMb, textWidthMbLp, textWidthPt
} from '../../../../constants/sizes';

const lineHeight = 62 / 52;

const lpTitleFontSize = 52 * sizeScale;
const ptTitleFontSize = 45 * sizeScale * ptFactor;
const mbTitleFontSize = 66 * sizeScale * ptFactor;

const lpTextFontSize = 29 * sizeScale;
const ptTextFontSize = 24 * sizeScale * ptFactor;
const mbTextFontSize = 35 * sizeScale * ptFactor;

export const getTitleMetrics = (orientation) => {
    const base = {
        fontFamily: FONTS.ACCENT,
        isUpperCase: true,
        lineHeight
    };

    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            ...base,
            fontSize: lpTitleFontSize,
            width: textWidthDp
        };
    }

    if (orientation === SIZE_OPTIONS.PORTRAIT) {
        return {
            ...base,
            fontSize: ptTitleFontSize,
            width: 0.9 * textWidthPt * ptFactor
        };
    }

    if (orientation === SIZE_OPTIONS.MOBILE_LANDSCAPE) {
        return {
            ...base,
            fontSize: ptTitleFontSize * 1.02,
            width: textWidthMbLp * ptFactor * 1.02
        };
    }

    return {
        ...base,
        fontSize: mbTitleFontSize,
        width: textWidthMb * ptFactor
    };
};

export const getTextMetrics = (orientation) => {
    const base = {
        fontFamily: FONTS.REGULAR,
        lineHeight
    };

    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            ...base,
            fontSize: lpTextFontSize,
            width: textWidthDp
        };
    }

    if (orientation === SIZE_OPTIONS.PORTRAIT) {
        return {
            ...base,
            fontSize: ptTextFontSize,
            width: textWidthPt * ptFactor
        };
    }

    if (orientation === SIZE_OPTIONS.MOBILE_LANDSCAPE) {
        return {
            ...base,
            fontSize: ptTextFontSize * 1.02,
            width: textWidthMbLp * ptFactor
        };
    }

    return {
        ...base,
        fontSize: mbTextFontSize,
        width: textWidthMb * ptFactor
    };
};

export const getShareTextMetrics = (orientation) => {
    const metrics = getTextMetrics(orientation);

    if (orientation === SIZE_OPTIONS.LANDSCAPE || orientation === SIZE_OPTIONS.PORTRAIT) {
        return {
            ...metrics,
            fontSize: metrics.fontSize * 0.6
        };
    }

    return {
        ...metrics,
        fontSize: metrics.fontSize * 0.75
    };
};

export const getTextLayoutStyle = (orientation) => {
    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            numLines: 2,
            marginBottom: 40 / 62
        };
    }

    if (orientation === SIZE_OPTIONS.MOBILE_LANDSCAPE) {
        return {
            numLines: 'auto',
            marginBottom: 30 / 62
        };
    }

    return {
        numLines: 'auto',
        marginBottom: 50 / 62
    };
};
